import { isFeatureEnabled } from 'owa-feature-flags';
import { InfoBarMessageRank } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import {
    getSharingDataFromLink,
    lazyGetSharingTipRecipientInfo,
    RecipientContainer,
} from 'owa-link-data';
import { lazyGetSharingIssuesForSharingData, SharingTipRecipientInfo } from 'owa-sharing-data';
import { SharingIssueLevel } from './SharingIssueLevel';

export function getHasSharingIssues(
    linkId: string,
    isLinkBeautified: boolean,
    getRecipientWells: () => RecipientContainer[],
    fromAddress: string
): SharingIssueLevel {
    const recipientWells = getRecipientWells();
    const sharingData = getSharingDataFromLink(linkId);

    // We do not check for sharing issues unless the link is beautified and the feature is enabled
    if (sharingData === null || !isFeatureEnabled('doc-attachment-contextualSharingTips')) {
        return SharingIssueLevel.None;
    }
    const getSharingTipRecipientInfo = lazyGetSharingTipRecipientInfo.tryImportForRender();
    const getSharingIssuesForSharingData = lazyGetSharingIssuesForSharingData.tryImportForRender();

    let recipientInfo: SharingTipRecipientInfo[] = [];
    if (getSharingTipRecipientInfo && getSharingIssuesForSharingData) {
        recipientInfo = getSharingTipRecipientInfo(recipientWells, fromAddress);

        const sharingIssues = getSharingIssuesForSharingData(sharingData, recipientInfo);
        if (sharingIssues && sharingIssues.length > 0) {
            if (sharingIssues.some(issue => issue.messageRank === InfoBarMessageRank.Error)) {
                return SharingIssueLevel.Error;
            }
            return SharingIssueLevel.Warning;
        }
    }

    return SharingIssueLevel.None;
}
